<mat-form-field class="fd-currency-input__container" color="accent">
  <mat-label>{{field?.label}}</mat-label>
  <div [formGroup]="parentForm">
      <input matInput
          currencyMask
          [formControlName]="field?.controlName" autocomplete="off" class="fd-currency-input__field"
          maxlength="21"
          [options]="getOptions()"
          [id]="field?.inputId || (field?.controlName + '-' + generatedInputId)"
          [required]="required || null" aria-label="Area code"
          type="setTypeInput()"
          [min]="field?.min"
          autocomplete="off"
          [attr.disabled]="field?.disabled || null"
          [readonly]="field?.readonly"
          tabindex="0"
          (click)="handleFocus($event)"
          (blur)="handleBlur($event)"
          (input)="handleChange($event)">
  </div>
  <mat-error *ngIf="hasError"><div *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div></mat-error>
</mat-form-field>
